import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "./langs";
// 引入英文语言包

Vue.use(VueI18n);

function AddressParameter(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

if (AddressParameter('language')) {
  if (AddressParameter('language') == 'zh_cn') {
    localStorage.setItem('lang', 'zh_cn')
  } else {
    localStorage.setItem('lang', AddressParameter('language'))
  }
} else {
  localStorage.setItem('lang', 'en')
}

const i18n = new VueI18n({
  locale: localStorage.lang || "en",
  messages
});

export default i18n;
